import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  AcceptedLocations,
  UserAddressModel,
  UserAddressType,
} from '@app/shared/models/user-address.model';
import { APP_CONFIG } from '@app/shared/models/constants';

@Injectable({
  providedIn: 'root',
})
export class UserAddressService {
  private readonly config = inject(APP_CONFIG);
  private readonly http = inject(HttpClient);

  static isAddressIncall(address: UserAddressModel) {
    return (
      (address?.addressType === UserAddressType.WORK_PUBLIC ||
        address?.addressType === UserAddressType.WORK_PICKUP ||
        address?.addressType === UserAddressType.WORK_PRIVATE) &&
      address.selected
    );
  }

  static isAddressOutcall(address: UserAddressModel) {
    return (
      (address?.addressType === UserAddressType.WORK_REGION ||
        address?.addressType === UserAddressType.WORK_DRAW ||
        address?.addressType === UserAddressType.WORK_RADIUS) &&
      address.selected
    );
  }

  constructor() {}

  getAddresses(): Observable<UserAddressModel[]> {
    return this.http
      .get<UserAddressModel[]>(`${this.config.apiV3}/user-addresses`)
      .pipe(catchError(() => of([])));
  }

  addAddress(address: UserAddressModel): Observable<UserAddressModel> {
    return this.http
      .post<UserAddressModel>(`${this.config.apiV3}/user-addresses`, address)
      .pipe(catchError(() => of(null)));
  }

  editAddress(address: UserAddressModel): Observable<UserAddressModel> {
    return this.http
      .put<UserAddressModel>(
        `${this.config.apiV3}/user-addresses/${address.id}`,
        address
      )
      .pipe(catchError(() => of(null)));
  }

  deleteAddress(addressId): Observable<any> {
    return this.http.delete(`${this.config.apiV3}/user-addresses/${addressId}`);
  }

  selectAddress(
    addressId: number,
    acceptedLocations: AcceptedLocations = null,
    outcall = false,
    deselect = false
  ): Observable<any> {
    return this.http.put(
      `${this.config.apiV3}/user-addresses/select/${addressId}/${outcall}?deselect=${deselect}`,
      acceptedLocations
    );
  }

  changeAcceptedLocations(
    acceptedLocations: AcceptedLocations
  ): Observable<any> {
    return this.http.put(
      `${this.config.apiV3}/user-addresses/locations`,
      acceptedLocations
    );
  }
}
